// Copyright 2026. WebPros International GmbH. All rights reserved.

import styled from 'styled-components';
import { COLORS } from 'admin/core/theme';

export const DialogSecondaryAction = styled.div`
    margin-top: 10px;

    .pul-button {
        width: 100%;
        max-height: none !important;
    }

    .pul-button__inner {
        justify-content: center;
    }
`;

export const HintText = styled.span`
    border-bottom: 1px dashed currentColor;
    cursor: help;
`;

export const DialogDivider = styled.hr`
    border: 0;
    border-top: 1px solid ${COLORS.GREY_30};
    margin: 16px 0 0;
`;
